import React from "react";
import Grid from "../Grid/grid";
import { motion } from "framer-motion";
import IconButton from "../input/icon-button";
import { ArrowRight } from "lucide-react";

function HeadSection({ onScroll }: { onScroll: () => void }) {
  return (
    <section className="w-full min-h-screen overflow-hidden relative flex items-center justify-center flex-col px-6 py-12 lg:p-16">
      <Grid size={100} direction="top-center" />
      <div className="absolute -top-52 -left-52 rounded-full w-[350px] h-[350px] sm:w-[450px] sm:h-[450px] md:w-[600px] md:h-[600px] bg-gradient-to-tl from-white/80 to-secondary/60 blur-xl -z-10" />
      <div className="absolute -bottom-52 -right-52 rounded-full w-[350px] h-[350px] sm:w-[450px] sm:h-[450px] md:w-[600px] md:h-[600px] bg-gradient-to-tr from-white/80 to-primary/60 blur-xl -z-10" />
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-center px-4 flex flex-col items-center justify-center gap-5"
      >
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-semibold"
        >
          Hire Expert Developers for Your Projects
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-base sm:text-lg text-gray-600 max-w-2xl sm:max-w-3xl md:max-w-4xl mx-auto"
        >
          Looking to hire skilled software developers? Our expert developers
          specialize in web development, mobile apps, and enterprise solutions.
          Get top-tier tech talent to accelerate your business growth today!
        </motion.p>
        <IconButton
          icon={<ArrowRight />}
          title="Let's Connect"
          onClick={onScroll}
        />
      </motion.div>
    </section>
  );
}

export default HeadSection;
